import Vue from 'vue';
import Vuex from 'vuex';
import atendimento from './modules/atendimento';
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Atendimento: atendimento,
    }
})
